import { render, staticRenderFns } from "./AdministratorAssignment.vue?vue&type=template&id=4ecabbbe&scoped=true&"
import script from "./AdministratorAssignment.vue?vue&type=script&lang=js&"
export * from "./AdministratorAssignment.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorAssignment.vue?vue&type=style&index=0&id=4ecabbbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecabbbe",
  null
  
)

export default component.exports